import React, { FunctionComponent } from 'react';
import Image from 'next/image';

const BlogDivider: FunctionComponent = () => {

    return (
        <div className="relative flex mb-6 md:my-2 lg:my-12 items-center">
            <div className="flex-grow border-t border-sp-light-grey"></div>
            <span className="flex-shrink text-gray-400">
                <Image
                    src='/icons/chevron.png'
                    alt=''
                    width={40}
                    height={40}
                    unoptimized={true}
                />
            </span>
            <div className="flex-grow border-t border-sp-light-grey"></div>
        </div>
    );
};

export default BlogDivider;